<template>
	<div class="public-product">
		<div class="hander">
			<div class="hander-first">
				<h4>共享产品</h4>
				<template>
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane label="共享陪护床" name="first">
							<!-- publicBed 共享陪护床 -->
							<public-bed v-if="bedVisible" ref="bed"></public-bed>
						</el-tab-pane>

						<el-tab-pane label="共享陪护椅" name="second">
							<!-- publicChair 共享陪护椅 -->
							<public-chair v-if="chairVisible" ref="chair"></public-chair>
						</el-tab-pane>

						<el-tab-pane label="共享轮椅" name="third">
							<!-- publicWheelchair 共享轮椅 -->
							<public-wheelchair v-if="wheelchairVisible" ref="wheelchair"></public-wheelchair>
						</el-tab-pane>
					</el-tabs>
				</template>
			</div>

			<div class="hander-second">
				<h4>秒到云平台</h4>
				<p>IOT平台</p>
			</div>

			<div class="hander-third">
				<h4>硬件开发</h4>
				<p>秒到通讯模块</p>
			</div>

			<div class="hander-four">
				<h4>工厂OEM</h4>
				<p>共享陪护椅改造套件</p>
			</div>
		</div>
		<!--
		<div class="content">
			<el-row :gutter="10">
				<el-col :span="6" v-for="o in 8" :key="o" style="padding: 5px">
					<el-card :body-style="{ padding: '0px' }" class="card-style">
						<img
							src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
							class="image"
						/>
						<div>
							<div style="text-align: left; padding-left: 5px">
								<h5>共享折叠床</h5>
								<p>秒道共享折叠床</p>
								<p>报价：123123</p>
							</div>
							<div class="footer-right">
								<p>所在地：浙江</p>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div> -->
	</div>
</template>
<script>
import PublicBed from "./components/publicBed.vue"
import PublicChair from "./components/publicChair.vue"
import PublicWheelchair from "./components/publicWheelchair.vue"
export default {
	components: {
		PublicBed,
		PublicChair,
		PublicWheelchair,
	},
	name: "PublicProducts",
	data() {
		return {
			currentDate: new Date(),

			activeName: "first", //默认显示tabs页第一页
			chairVisible: false,
			wheelchairVisible: false,
		}
	},
	created() {
		this.bedVisible = true
	},
	methods: {
		handleClick(tab) {
			if (tab.name === "first") {
				this.bedVisible = true
				this.chairVisible = false
				this.wheelchairVisible = false
			} else if (tab.name === "second") {
				this.bedVisible = false
				this.chairVisible = true
				this.wheelchairVisible = false
			} else if (tab.name === "third") {
				this.bedVisible = false
				this.chairVisible = false
				this.wheelchairVisible = true
			}
		},
	},
}
</script>
<style scoped>
/* .public-product {
  height: 100;
} */
.hander {
	width: 100%;
	/* background: red; */
	height: 100px;
	display: flex;
}
.hander div {
	flex: 1;
	text-align: left;
	margin-left: 5px;
	/* border: 1px solid black; */
}

.hander div span,
p {
	font-size: 13px;
}

.hander div span {
	padding-right: 10px;
}

.content {
	height: 100%;
	background: lawngreen;
	padding: 10px;
}

.time {
	font-size: 13px;
	color: #999;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.footer-right p {
	padding-right: 5px;
	font-weight: 550;
	text-align: right;
}

.image {
	width: 100%;
	display: block;
	/* height: 250px; */
}

.clearfix:before,
.clearfix:after {
	display: table;
	content: "";
}

.clearfix:after {
	clear: both;
}

/* .card-style {
    width: 200px;
  } */
</style>
